// components/common/SignaturePad.jsx
import React from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { RotateCcw } from 'lucide-react';

export class SignaturePad extends React.Component {
  sigRef = React.createRef();

  clear = () => {
    this.sigRef.current?.clear();
  };

  isEmpty = () => {
    return !this.sigRef.current || this.sigRef.current.isEmpty();
  };

  getSignature = () => {
    if (this.isEmpty()) return null;
    try {
      return this.sigRef.current.getTrimmedCanvas().toDataURL('image/png');
    } catch (e) {
      // Fallback in case getTrimmedCanvas isn't available in this version/environment
      return this.sigRef.current.getCanvas().toDataURL('image/png');
    }
  };

  render() {
    const { disabled } = this.props;

    return (
      <div className={`signature-pad-box ${disabled ? 'signature-pad-box--disabled' : ''}`}>
        <div className="signature-pad-canvas-wrap">
          <SignatureCanvas
            ref={this.sigRef}
            penColor="#111"
            canvasProps={{ className: 'signature-pad-canvas' }}
            clearOnResize={false}
          />
        </div>
        <div className="signature-pad-actions">
          <span className="signature-pad-hint">Sign above using your mouse or touchscreen</span>
          <button
            type="button"
            className="signature-pad-clear-btn"
            onClick={this.clear}
            disabled={disabled}
          >
            <RotateCcw size={14} /> Clear
          </button>
        </div>
      </div>
    );
  }
}